import {authConfig} from 'lib/auth-config';
import {OktaAuth} from '@okta/okta-auth-js';

export const oktaAuth = new OktaAuth({...authConfig});

export function isAnonymousAuth(error) {
  return error.errorCode === 'login_required';
}
